import { create } from 'zustand';

/**
 * Ask for the MANAGER's password (the fixed user with LoginName 'Admin') —
 * the gate on removing items from, or cancelling, a held order.
 *
 * `askManagerPassword()` opens <ManagerPasswordModal/> and resolves with the
 * password once the server has confirmed it, or null when the cashier backs
 * out. Callable from anywhere (a click handler, the order path), no React
 * context needed.
 */
interface ManagerPromptState {
  open: boolean;
  /** Why it is being asked, shown in the dialog. */
  reason: { en: string; ar: string } | null;
  resolve: ((password: string | null) => void) | null;
  finish: (password: string | null) => void;
}

export const useManagerPrompt = create<ManagerPromptState>((set, get) => ({
  open: false,
  reason: null,
  resolve: null,
  finish: (password) => {
    const r = get().resolve;
    set({ open: false, reason: null, resolve: null });
    r?.(password);
  },
}));

export function askManagerPassword(reason: { en: string; ar: string }): Promise<string | null> {
  // A second request while one is open replaces it; the first resolves null.
  useManagerPrompt.getState().resolve?.(null);
  return new Promise((resolve) => {
    useManagerPrompt.setState({ open: true, reason, resolve });
  });
}
